<template>
  <div class="">
    <div class="event-children" v-for="rule in rules" :key="rule">
      <div class="event-children-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#e95348" class="bi bi-stopwatch" viewBox="0 0 16 16" alt="En progreso">
          <path d="M8.5 5.6a.5.5 0 1 0-1 0v2.9h-3a.5.5 0 0 0 0 1H8a.5.5 0 0 0 .5-.5V5.6z"/>
          <path d="M6.5 1A.5.5 0 0 1 7 .5h2a.5.5 0 0 1 0 1v.57c1.36.196 2.594.78 3.584 1.64a.715.715 0 0 1 .012-.013l.354-.354-.354-.353a.5.5 0 0 1 .707-.708l1.414 1.415a.5.5 0 1 1-.707.707l-.353-.354-.354.354a.512.512 0 0 1-.013.012A7 7 0 1 1 7 2.071V1.5a.5.5 0 0 1-.5-.5zM8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3z"/>
        </svg>                            
      </div>
      <div class="event-children-content">
        <div class="event-children-title">{{ rule | textRule }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rules: null,
  },
  methods: {
    textRule(value) {
      
    }
  },
  filters: {
    textRule: function(value) {
      const arrayText = value.split(' ')
      const description = arrayText[0]
      switch (description) {
        case 'cv':
          return 'Hoja de vida'
        case 'habeas_data':
          return 'Habeas data'
        case 'academic_references_pending_for_create':
          return 'Esperando creación de referencias académicas'
        case 'laboral_references_pending_for_create':
          return 'Esperando creación de referencias laborales'
        case 'family_references_pending_for_create':
          return 'Esperando creación de referencias académicas'
        case 'personal_references_pending_for_create':
          return 'Esperando creación de referencias personales'
        case 'academic_references_pending_for_request_validations':
          return 'Solicitud de verificación de referencia académica pendiente'
        case 'laboral_references_pending_for_request_validations':
          return 'Solicitud de verificación de referencia laboral pendiente'
        case 'family_references_pending_for_request_validations':
          return 'Solicitud de verificación de referencia familiar pendiente'
        case 'personal_references_pending_for_request_validations':
          return 'Solicitud de verificación de referencia personal pendiente'
        case 'academic_references_pending_for_verifications_response':
          return 'Esperando verificaciones académicas'
        case 'laboral_references_pending_for_verifications_response':
          return 'Esperando verificaciones laborales'
        case 'family_references_pending_for_verifications_response':
          return 'Esperando verificaciones familiares'
        case 'personal_references_pending_for_verifications_response':
          return 'Esperando verificaciones personales'
          
        case 'academic_reference_verified':
          return 'Referencia académica verificada'                                                
        case 'laboral_reference_verified':
          return 'Referencia laboral verificada'                                                
        case 'family_reference_verified':
          return 'Referencia familiar verificada'                                                
        case 'personal_reference_verified':
          return 'Referencia personal verificada'
        case 'request_data_candidate_finished':
          return 'El candidato respondió la solicitud de información'
        case 'assignment_academic_finished':
          return 'Asignación académica'
        case 'assignment_personal_finished':
          return 'Asignación personal'
        case 'assignment_laboral_finished':
          return 'Asignación laboral'
        case 'assignment_antecedents_finished':
          return 'Asignación de antecedentes'                        
        default:
          return description
      }      
    }
  }
};
</script>

<style scoped>
</style>